import { FieldRenderProps } from '@progress/kendo-react-form';

type RadioOption = {
  value: string;
  label: string;
  detailPrimary?: string;
  detailSecondary?: string;
};

export const handleOnChange = (props: FieldRenderProps, data: string) => {
  props.onChange({ value: data, target: { value: data } });
  props.onBlur();
};

const RadioWithDetails = (props: FieldRenderProps) => {
  return (
    (props?.data && (
      <div
        id={`${props.id}-group`}
        data-testid={`${props.id}-group`}
        className={`tw-flex tw-flex-col tw-max-w-[500px] tw-gap-3 ${
          props?.classnames || ''
        }`}
        role="radiogroup"
      >
        {props.data.map((option: RadioOption, index: number) => {
          const isSelected = option.value === props.value;
          const isDisabled = props.disabled;

          return (
            <label
              key={option.value}
              htmlFor={`${props.id}-${index}`}
              className={`tw-inline-flex tw-items-start tw-gap-3 tw-py-3 tw-px-4 tw-mb-3
                tw-border-2 tw-rounded-2xl tw-transition-colors tw-duration-200
                ${
                  isSelected
                    ? 'tw-border-[#0056b3] tw-bg-[#e7f1ff]'
                    : 'tw-border-[#ccc] tw-bg-white'
                }
                ${
                  isDisabled
                    ? 'tw-cursor-not-allowed tw-opacity-60'
                    : 'tw-cursor-pointer hover:tw-border-[#0056b3]'
                }
              `}
            >
              <input
                type="radio"
                id={`${props.id}-${index}`}
                name={props.name}
                value={option.value}
                checked={isSelected}
                onChange={() => handleOnChange(props, option.value)}
                disabled={isDisabled}
                className="tw-w-[18px] tw-h-[18px] tw-mt-1 tw-accent-unm-interactive01-400"
              />

              <div className="tw-flex tw-flex-col">
                {/* Main label */}
                <span className="tw-font-medium">{option.label}</span>

                {/* First detail */}
                {option.detailPrimary && (
                  <span className="tw-text-sm tw-text-unm-interactive01-400 tw-font-semibold">
                    {option.detailPrimary}
                  </span>
                )}

                {/* Second detail */}
                {option.detailSecondary && (
                  <span className="tw-text-sm tw-text-gray-500">
                    {option.detailSecondary}
                  </span>
                )}
              </div>
            </label>
          );
        })}
      </div>
    )) ||
    null
  );
};

export default RadioWithDetails;
